import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M4.947 10.36a.667.667 0 1 0 .945.94.667.667 0 0 0-.945-.94m0-5.66a.667.667 0 1 0 .945.94.667.667 0 0 0-.945-.94m3.3 6.667a.666.666 0 1 0 .666.666.667.667 0 0 0-.666-.7zm-4-4a.667.667 0 1 0 .666.666.667.667 0 0 0-.666-.7zm4-4a.667.667 0 1 0 .666.666.667.667 0 0 0-.666-.7zm2.36 1.366a.667.667 0 1 0 .94 0 .667.667 0 0 0-.94-.033zm4.2 0a7.333 7.333 0 1 0-5.234 10.494 2.58 2.58 0 0 0 1.667-1.1A2.8 2.8 0 0 0 11.647 12a4 4 0 0 1-.067-.667 3.33 3.33 0 0 1 2-3.04 2.56 2.56 0 0 0 1.373-1.5 2.67 2.67 0 0 0-.146-2.073zM13.673 6.36a1.26 1.26 0 0 1-.666.727 4.666 4.666 0 0 0-2.667 5.18 1.44 1.44 0 0 1-.207 1.1 1.2 1.2 0 0 1-.806.533q-.535.1-1.08.1a6 6 0 0 1-6-6.187A6.033 6.033 0 0 1 7.9 2h.34a6 6 0 0 1 5.373 3.333c.153.317.175.681.06 1.014zm-5.426.973a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })